import { useGetQuoteModuleSettings } from '@/views/screens/Quote/hooks';
import { useSelector } from 'react-redux';
import { isShowAdministrator, isShowApprover, isShowCreator } from '../redux/auth/AuthSelectors';
import { QUOTE_STATUSES } from '../views/screens/Shipment/components/QuoteCard/constants';

export const buttonTypes = {
  sendForReview: 'Send For Review',
  spotBID: 'Spot BID',
  cancelQuote: 'Cancel Quote',
  awardBid: 'Award Bid',
  unawardBid: 'Unaward Bid',
  save: 'Save',
  awarded: 'Awarded',
};

export const useShowButton = (buttonType, status) => {
  const showCreator = useSelector(isShowCreator);
  const showAdministrator = useSelector(isShowAdministrator);
  const showApprover = useSelector(isShowApprover);
  const { data: quoteModuleSettings } = useGetQuoteModuleSettings();
  const isApprovalEnabled = quoteModuleSettings?.isApprovalEnabled;

  switch (buttonType) {
    case buttonTypes.sendForReview:
      return status === QUOTE_STATUSES.new && isApprovalEnabled;

    case buttonTypes.spotBID:
      return (
        (status === QUOTE_STATUSES.new || status === QUOTE_STATUSES.internalReview) &&
        (!isApprovalEnabled || showAdministrator || showApprover)
      );

    case buttonTypes.cancelQuote:
      if (showCreator || status === QUOTE_STATUSES.cancelled || !isApprovalEnabled) {
        return false;
      }

      return true;

    case buttonTypes.awardBid:
      return (
        (status === QUOTE_STATUSES.readyForAward || status === QUOTE_STATUSES.unAwarded) &&
        (!isApprovalEnabled || showAdministrator || showApprover)
      );

    case buttonTypes.unawardBid:
      return status === QUOTE_STATUSES.awarded && (!isApprovalEnabled || showAdministrator || showApprover);

    case buttonTypes.save:
      return (
        status !== QUOTE_STATUSES.awarded && status !== QUOTE_STATUSES.cancelled && (!isApprovalEnabled || !showCreator)
      );

    case buttonTypes.awarded:
      return status === QUOTE_STATUSES.awarded;

    default:
      return false;
  }
};
